// Las ligas internas a una colección llegan con el filtro «Disponible» puesto (dueño, 2026-10-17).
// El href se cambia en el momento del clic, no al cargar: el HTML conserva las ligas limpias, que es lo que
// lee Google, y la colección sin filtro sigue siendo la página oficial (su canonical no lleva el filtro).
(() => {
  const PARAM = 'filter.v.availability';

  const conFiltro = (a) => {
    if (a.target && a.target !== '_self' && a.target !== '_blank') return null;
    let url;
    try {
      url = new URL(a.getAttribute('href') || '', location.href);
    } catch {
      return null;
    }
    if (url.origin !== location.origin) return null;
    // Sólo /collections/<handle>: no /collections/<handle>/products/…, ni el listado de colecciones.
    if (!/^\/collections\/[^/]+\/?$/.test(url.pathname)) return null;
    // Si ya trae filtros, orden o página, se respeta tal cual.
    if (url.search) return null;
    // Una liga a la misma colección en la que está el cliente es «quitar filtros»: no se vuelve a poner.
    if (url.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '')) return null;
    url.searchParams.set(PARAM, '1');
    return url.pathname + url.search + url.hash;
  };

  const alClic = (evento) => {
    const a = evento.target instanceof Element ? evento.target.closest('a[href]') : null;
    if (!a || a.closest('facets-form-component')) return;
    const nueva = conFiltro(a);
    if (nueva) a.setAttribute('href', nueva);
  };

  // Fase de captura: el href cambia antes de que el navegador (o el tema) siga la liga.
  document.addEventListener('click', alClic, true);
  document.addEventListener('auxclick', alClic, true);
})();
